// extracted by mini-css-extract-plugin
export default {"wrapper":"PlayerIframe_wrapper__BZVqr","container":"PlayerIframe_container__Xa6eK","iframe":"PlayerIframe_iframe__XVqxF","fullscreenBtn":"PlayerIframe_fullscreenBtn__uaIWV"};